import { SOVTemplateBean, SovTemplateControllerApi, ItemResponseSOVTemplateBeanObject, ListResponseSOVTemplateBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'
import { processError } from '../../../api/customFetch'

class SOVTemplateApi extends BaseApi {
    api: SovTemplateControllerApi

    constructor() {
        super()
        this.api = new SovTemplateControllerApi(configuration, configuration.basePath, this.customFetch)
    }

    list(size: number = 20, page: number = 1, search?): Promise<ListResponseSOVTemplateBean> {
        return this.api.sovTemplateList(search, { query: { size, page } }).then(list => {
            return Promise.resolve(list)
        }).catch(err => {
            return processError(err)
        })
    }

    all(): Promise<ListResponseSOVTemplateBean> {
        return this.api.sovTemplateList().then(list => {
            return Promise.resolve(list)
        }).catch(err => {
            return processError(err)
        })
    }

    create(deal: SOVTemplateBean): Promise<ItemResponseSOVTemplateBeanObject> {
        return this.api.createSovTemplate(deal).then(created => {
            return Promise.resolve(created)
        }).catch(err => {
            return processError(err)
        })
    }

    edit(id: number, deal: SOVTemplateBean): Promise<ItemResponseSOVTemplateBeanObject> {
        return this.api.editSovTemplate(deal, id).then(updated => {
            return Promise.resolve(updated)
        }).catch(err => {
            return processError(err)
        })
    }

    view(id: number): Promise<ItemResponseSOVTemplateBeanObject> {
        return this.api.sovTemplate(id).then(deal => {
            return Promise.resolve(deal)
        }).catch(err => {
            return processError(err)
        })
    }

    delete(id: number): Promise<void> {
        return this.api.deleteSovTemplate(id).then(() => {
            return Promise.resolve()
        }).catch(err => {
            return processError(err)
        })
    }
}

const sovTemplateApi = new SOVTemplateApi()
export default sovTemplateApi